export interface ColDef {
  id: string
  label: string
  defaultVisible: boolean
  defaultWidth: number
  align: 'left' | 'right' | 'center'
}

export const COLUMNS: ColDef[] = [
  { id: 'article_number',          label: 'Art.nr',         defaultVisible: true,  defaultWidth: 90,  align: 'left'   },
  { id: 'gtin',                    label: 'GTIN',           defaultVisible: false, defaultWidth: 115, align: 'left'   },
  { id: 'description',             label: 'Omschrijving',   defaultVisible: true,  defaultWidth: 155, align: 'left'   },
  { id: 'ordrsp_qty',              label: 'Besteld',        defaultVisible: true,  defaultWidth: 62,  align: 'right'  },
  { id: 'desadv_qty',              label: 'Geleverd',       defaultVisible: true,  defaultWidth: 62,  align: 'right'  },
  { id: 'invoice_qty',             label: 'Gefact.',        defaultVisible: true,  defaultWidth: 62,  align: 'right'  },
  { id: 'invoice_invoicing_units', label: 'Fact.eenh.',     defaultVisible: false, defaultWidth: 74,  align: 'right'  },
  { id: 'price_basis_qty',         label: 'Pr.basis',       defaultVisible: false, defaultWidth: 68,  align: 'right'  },
  { id: 'unit',                    label: 'Eenh.',          defaultVisible: true,  defaultWidth: 44,  align: 'left'   },
  { id: 'ordrsp_price',            label: 'Prijs OR',       defaultVisible: true,  defaultWidth: 78,  align: 'right'  },
  { id: 'invoice_price',           label: 'Prijs fact.',    defaultVisible: true,  defaultWidth: 94,  align: 'right'  },
  { id: 'agreed_gross_price',      label: 'Catalogus',      defaultVisible: true,  defaultWidth: 78,  align: 'right'  },
  { id: 'agreed_net_price',        label: 'Afgesproken',    defaultVisible: true,  defaultWidth: 94,  align: 'right'  },
  { id: 'ordrsp_net_amount',       label: 'Bedrag OR',      defaultVisible: false, defaultWidth: 84,  align: 'right'  },
  { id: 'invoice_net_amount',      label: 'Bedrag fact.',   defaultVisible: false, defaultWidth: 84,  align: 'right'  },
  { id: 'vat_percentage',          label: 'BTW %',          defaultVisible: true,  defaultWidth: 54,  align: 'right'  },
  { id: 'vat_amount',              label: 'BTW bedrag',     defaultVisible: true,  defaultWidth: 84,  align: 'right'  },
  { id: 'status',                  label: 'Status',         defaultVisible: true,  defaultWidth: 112, align: 'center' },
  { id: 'status_details',          label: 'Validatie',      defaultVisible: true,  defaultWidth: 200, align: 'left'   },
]

export const STORAGE_VIS    = 'linetable_vis_v2'
export const STORAGE_WIDTHS = 'linetable_widths_v1'

export function loadVisible(): Set<string> {
  try {
    const s = localStorage.getItem(STORAGE_VIS)
    if (s) {
      const arr = JSON.parse(s)
      if (Array.isArray(arr)) return new Set(arr)
    }
  } catch { /* ignore */ }
  return new Set(COLUMNS.filter(c => c.defaultVisible).map(c => c.id))
}

export function loadWidths(): Record<string, number> {
  try {
    const s = localStorage.getItem(STORAGE_WIDTHS)
    if (s) {
      const obj = JSON.parse(s)
      if (obj && typeof obj === 'object') return obj
    }
  } catch { /* ignore */ }
  return Object.fromEntries(COLUMNS.map(c => [c.id, c.defaultWidth]))
}
